module.exports = __webpack_public_path__ + "static/media/senti.724d221f.ico";